import React, { useState } from "react";
import styles from "./styles.module.scss";
import SlideNavigation, { OnNavigationType } from "../_basic/SlideNavigation";
import { FreeTextSlideType } from "../../../types/freeTextSlide";

interface FreeTextSlideProps {
  data: FreeTextSlideType;
  onNavigation: OnNavigationType;
}

const FreeTextSlide: React.FC<FreeTextSlideProps> = ({
  data,
  onNavigation,
}) => {
  const [showContent, setShowContent] = useState(
    data.explanation.expandedByDefault
  );
  const [text, setText] = useState("");
  const [error, setError] = useState("");

  const handleTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const inputText = e.target.value;
    setText(inputText);
    if (inputText.length > (data.maximumLength || 200)) {
      setError(data.freeTextInput.errorMessages.max_length);
    } else {
      setError("");
    }
  };

  return (
    <div className={styles.freeTextSlideContainer}>
      <div className={styles.titleContainer}>
        <div className={styles.subTitle}>{data.subtitle}</div>
        <div className={styles.title}>{data.title}</div>
      </div>
      <div
        className={`${styles.subTitle} ${styles.content}`}
        onClick={() => setShowContent(!showContent)}>
        <img
          src={showContent ? "/down-arrow.svg" : "/up-arrow.svg"}
          alt="down-arrow"
          width={10}
          height={10}
        />
        {data.explanation.title}
      </div>
      {showContent && (
        <div className={styles.contentContainer}>
          <div className={styles.title}>{data.explanation.content}</div>
        </div>
      )}
      <textarea
        className={styles.textArea}
        placeholder={data.freeTextInput.placeholder}
        value={text}
        onChange={handleTextChange}
      />
      {error && <div className={styles.errorMessage}>{error}</div>}

      <SlideNavigation
        onNavigation={() => onNavigation(1)}
        nextText={"Next"}
        selected={[12]}
      />
    </div>
  );
};

export default FreeTextSlide;
